export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11643.cb942947.jpg";